import { CACHING_PREFIX, FAKE_TTL, LS_ROOT_CATEGORY_ID, tvpilGetLocalCache } from '@kaltura-ott/tvpil';
import { computed, observable } from 'mobx';

import { FEATURE_ENABLER_VARIATIONS, featureEnabler } from '../../utils';
import { envs, stages } from '../config';

import { setSwitchEnvParamsToStorage } from './debugMenu.service';
export interface DebugMenuEnvItem {
  partnerId: number;
  title: string;
  envs: {
    name: string;
    url: string;
  }[];
  name: string;
}

/**
 * @category Store
 */
export class DebugMenuStore {
  @observable items: DebugMenuEnvItem[] = [];
  static isForceDebug? = false;
  static customRootID = 0;
  @computed static get isMutableRootCategoryId(): boolean {
    return (
      DebugMenuStore.isForceDebug ||
      featureEnabler.variations.get(FEATURE_ENABLER_VARIATIONS.debugCategoryTree) ||
      false
    );
  }

  constructor(applicationName: string) {
    const platform = applicationName.split('.');
    this.items = this.generateItems(platform[platform.length - 1]);
  }

  @computed
  static get rootCategoryId(): number | undefined {
    if (DebugMenuStore.isMutableRootCategoryId && DebugMenuStore.customRootID) {
      return DebugMenuStore.customRootID;
    }
    return undefined;
  }

  static setRootCategoryId(id: number) {
    const cache = tvpilGetLocalCache();
    cache.setItem(LS_ROOT_CATEGORY_ID, id, FAKE_TTL);
  }

  private generateItems = (platform: string): DebugMenuEnvItem[] => {
    return envs.map((item) => {
      const { id: partnerId, name, title } = item;

      const envs = stages.map((stage) => {
        const { name, url } = stage;

        return {
          name,
          url: `https://api.${url}.ott.kaltura.com`,
        };
      });

      return {
        partnerId,
        title,
        envs,
        name: `${name}${platform}`,
      };
    });
  };

  public switchEnv = (partnerIdIndex: number, envIndex: number) => {
    const item = this.items[partnerIdIndex];

    setSwitchEnvParamsToStorage({
      applicationName: item.name,
      endpoint: item.envs[envIndex].url,
      partnerId: item.partnerId,
    });
  };

  public clearPersistCache = () => {
    const cache = tvpilGetLocalCache();
    cache.removeAllBySubPrefix(CACHING_PREFIX);
  };
}
